import { CompoundButtonStyles as FluentCompoundButtonStyles, colorBrandBackground, colorNeutralForegroundOnBrand, colorNeutralStrokeOnBrand, colorBrandBackgroundHover, colorBrandBackgroundPressed, colorStrokeFocus2, shadow2 } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${FluentCompoundButtonStyles}
  :host([appearance='primary-on-brand']) {
    background-color: ${colorBrandBackground};
    color: ${colorNeutralForegroundOnBrand};
    border-color: ${colorNeutralStrokeOnBrand};
  }

  :host([appearance="primary-on-brand"]) ::slotted([slot="description"]) {
    color: ${colorNeutralForegroundOnBrand};
  }

  :host(
    [appearance="primary-on-brand"]:is(:hover, :hover:active):not(
        :focus-visible
      )
  ) {
    border-color: ${colorNeutralStrokeOnBrand};
  }

  :host([appearance="primary-on-brand"]:is(:hover, :hover:active)) {
    color: ${colorNeutralForegroundOnBrand};
    background-color: ${colorBrandBackgroundHover};
  }

  :host([appearance="primary-on-brand"]:hover:active) {
    background-color: ${colorBrandBackgroundPressed};
  }

  :host([appearance="primary-on-brand"]:focus-visible) {
    border-color: ${colorNeutralForegroundOnBrand};
    box-shadow:
      ${shadow2},
      0 0 0 2px ${colorStrokeFocus2};
  }
`;
//# sourceMappingURL=compound-button.styles.js.map